import {Component, Input} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {SigningStatusEnum} from '../../enums/enum';
import {RoleDetail} from '../../signing-page/signing-page.dto';
import {ForwardSignatureComponent} from './forward-signature/forward-signature.component';
import {InviteToReadComponent} from './invite-to-read/invite-to-read.component';
import {InviteToSignComponent} from './invite-to-sign/invite-to-sign.component';
import {RejectDocumentComponent} from './reject-document/reject-document.component';

@Component({
  selector: 'app-more',
  templateUrl: './more.component.html',
  styleUrl: './more.component.scss'
})
export class MoreComponent{
  @Input() roleId:string;
  @Input() document_id:number;
  @Input() is_sender:number;
  @Input() roleDetail:RoleDetail;
  constructor(private modalService: NgbModal){}
  public signingStatusEnum = SigningStatusEnum;

  /**
   * invite the person to sign a document
   */
  inviteToSign() {
    if([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED, this.signingStatusEnum.READONLY].includes(this.roleDetail.recipient_role_detail.status) && this.roleDetail.allow_to_invite === 1){
      const inviteToSign:NgbModalRef = this.modalService.open(InviteToSignComponent, {
        size: 'sm',
        backdrop: 'static',
      });
      inviteToSign.componentInstance.roleId = this.roleId;
      inviteToSign.componentInstance.document_id = this.document_id;
      inviteToSign.componentInstance.is_sender = this.is_sender;
    }
  }

  /**
   * invite the person to read a document
   */
  inviteToRead() {
    if([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED, this.signingStatusEnum.READONLY].includes(this.roleDetail.recipient_role_detail.status) && this.roleDetail.allow_to_read === 1){
      const inviteToSign:NgbModalRef = this.modalService.open(InviteToReadComponent, {
        size: 'sm',
        backdrop: 'static',
      });
      inviteToSign.componentInstance.roleId = this.roleId;
      inviteToSign.componentInstance.document_id = this.document_id;
      inviteToSign.componentInstance.is_sender = this.is_sender;
    }
  }
  
  rejectDocument(){
    if([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED, this.signingStatusEnum.READONLY].includes(this.roleDetail.recipient_role_detail.status)){
      const rejectDocument:NgbModalRef = this.modalService.open(RejectDocumentComponent);
      rejectDocument.componentInstance.roleId = this.roleId;
      rejectDocument.componentInstance.document_id = this.document_id;
      rejectDocument.componentInstance.is_sender = this.is_sender;
    }
  }

  forwardSignature(){
    if([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED, this.signingStatusEnum.READONLY].includes(this.roleDetail.recipient_role_detail.status) && this.roleDetail.allow_to_forward === 1){
      const forwardSignature:NgbModalRef = this.modalService.open(ForwardSignatureComponent);
      forwardSignature.componentInstance.roleId = this.roleId;
      forwardSignature.componentInstance.document_id = this.document_id;
      forwardSignature.componentInstance.is_sender = this.is_sender;
      forwardSignature.componentInstance.roleDetail = this.roleDetail;
    }
  }

}
